"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sessionStorage = require("./sessionStorage");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    "non-persistent": function nonPersistent() {
        return [];
    },
    "persistent-session": function persistentSession() {
        return (0, _sessionStorage2.default)('logging');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/queueTypes.js
// module id = 756
// module chunks = 0